<div class="table-container">
  @if (datasource.data.length > 0) {
    <div class="action-container">
      <button rds-secondary-button (click)="exportToCSV()">
        Export as CSV
      </button>
    </div>
    <div class="table-wrapper">
      <table rds-table [dataSource]="datasource">
        <ng-container rdsColumnDef="id">
          <th rds-header-cell *rdsHeaderCellDef>booking id</th>
          <td rds-cell *rdsCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container rdsColumnDef="eventName">
          <th rds-header-cell *rdsHeaderCellDef>Event Name</th>
          <td rds-cell *rdsCellDef="let element">{{ element.eventName }}</td>
        </ng-container>

        <ng-container rdsColumnDef="startTime">
          <th rds-header-cell *rdsHeaderCellDef>startTime</th>
          <td rds-cell *rdsCellDef="let element">
            {{ element.startTime | date: 'dd MMM yyyy HH:mm' }}
          </td>
        </ng-container>

        <ng-container rdsColumnDef="endTime">
          <th rds-header-cell *rdsHeaderCellDef>endTime</th>
          <td rds-cell *rdsCellDef="let element">
            {{ element.endTime | date: 'dd MMM yyyy HH:mm' }}
          </td>
        </ng-container>

        <ng-container rdsColumnDef="createTime">
          <th rds-header-cell *rdsHeaderCellDef>createTime</th>
          <td rds-cell *rdsCellDef="let element">
            {{ element.createTime | date: 'dd MMM yyyy HH:mm' }}
          </td>
        </ng-container>

        <ng-container rdsColumnDef="numberOfPeople">
          <th rds-header-cell *rdsHeaderCellDef>numberOfPeople</th>
          <td rds-cell *rdsCellDef="let element">
            {{ element.numberOfPeople }}
          </td>
        </ng-container>

        <ng-container rdsColumnDef="roomType">
          <th rds-header-cell *rdsHeaderCellDef>roomType</th>
          <td rds-cell *rdsCellDef="let element">{{ element.roomType }}</td>
        </ng-container>

        <ng-container rdsColumnDef="roomName">
          <th rds-header-cell *rdsHeaderCellDef>roomName</th>
          <td rds-cell *rdsCellDef="let element">{{ element.roomName }}</td>
        </ng-container>

        <ng-container rdsColumnDef="status">
          <th rds-header-cell *rdsHeaderCellDef>status</th>
          <td rds-cell *rdsCellDef="let element">{{ element.status }}</td>
        </ng-container>

        <ng-container rdsColumnDef="services">
          <th rds-header-cell *rdsHeaderCellDef>Services</th>
          <td rds-cell *rdsCellDef="let element">{{ element.services }}</td>
        </ng-container>

        <tr rds-header-row *rdsHeaderRowDef="displayedColumns"></tr>
        <tr rds-row *rdsRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div class="paginator-wrapper">
      <rds-paginator
        [length]="paginationState.length"
        [pageIndex]="paginationState.pageIndex"
        [pageSize]="paginationState.pageSize"
        [pageSizeOptions]="[10, 20, 50]"
        showFirstLastButtons
        (page)="onPageChange($event)"></rds-paginator>
    </div>
  }
</div>
